// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"w9kYma96","styledButtonTracked":"RGMk7vXR w9kYma96"};